import { useContext } from 'react';

import { AiFeedbackVisibilityContext } from '../../components/AiFeedbackVisibilityContext/AiFeedbackVisibilityContext';

export const useShowAiFeedback = () => {
  const context = useContext(AiFeedbackVisibilityContext);

  if (!context) {
    throw new Error('Missing AiFeedbackVisibilityContext');
  }

  return context;
};
